<template>
    <div class="animated fadeIn efficiency">
        <filters :scope="filtersScope">
        </filters>
        <modal small title="" v-model="confirmModal" effect="fade/zoom">
          <div slot="modal-header" class="modal-header">
            <div style="font-size: 1.5em;text-align: center;">{{ $t('verbs.edit') }}</div>
          </div>
          <div style="text-align: center;">
            <button type="button" class="btn btn-outline-info" @click="confirmValue(true)">
              {{ $t('verbs.apply') }}
            </button>
            <button type="button" class="btn btn-outline-info" @click="confirmValue(false)">
              {{ $t('verbs.close') }}
            </button>
          </div>
          <div slot="modal-footer" class="modal-footer">
          </div>
        </modal>

        <modal large title="" v-model="exportHistiryModal" effect="fade/zoom">
            <div slot="modal-header" class="modal-header">
            </div>
            <StatisticTable :headColumns="exportHeadColumns"
                            :footColumns="exportFootColumns"
                            :rows="exportRows"
                            :title="`${$t('statistic.payment_history')}`">
            </StatisticTable>
            <div slot="modal-footer" class="modal-footer">
                <button type="button" class="btn btn-outline-info" @click="exportHistiryModal = false">
                    {{ $t('verbs.close') }}
                </button>
            </div>
        </modal>

        <StatisticTable :headColumns="headColumns"
                        :footColumns="footColumns"
                        :rows="rows"
                        :title="`${$t('pages.webmaster_individual_rates')}`"
                        @changeElem="changeElem">
                        <template slot="table-actions">
                          <button class="btn-close" @click="toggleExportHistoryModal()"><i class="fa fa-book"></i></button>
                        </template>
        </StatisticTable>
    </div>
</template>

<script>
  import Filters from '../../../components/Filters.vue'
  import API from '../../../api/API'
  import Storage from '../../../api/Storage'
  import { map, orderBy } from 'lodash'
  import { modal } from 'vue-strap'
  import Helper from '../../../api/Helper'
  import TypeColor from '../../../assets/TypeColor'
  import StatisticTable from '../../../components/StatisticTable.vue'

  export default {
    name: 'Payments',
    components: {
      Filters,
      StatisticTable,
      modal
    },
    data () {
      return {
        filtersScope: {
          dateFilter: true,
          offerFilter: true
        },
        isLoading: false,
        Storage: Storage,
        TypeColor: TypeColor,
        confirmModal: false,
        Helper: Helper,
        country: null,
        oldValue: {},
        ChangeValue: String,
        headColumns: [
          {label: this.$root.$t('statistic.webmaster'), field: 'webmaster'},
          {label: this.$root.$t('statistic.total'), field: 'total'},
          {label: this.$root.$t('statistic.payment_fix'), field: 'payment_fix'},
          {label: this.$root.$t('statistic.last_payment'), field: 'last_payment'},
          {label: this.$root.$t('statistic.average_payment'), field: 'average_payment'},
          {label: this.$root.$t('statistic.buyout'), field: 'buyout', colspan: 2},
          {label: this.$root.$t('statistic.return'), field: 'return', colspan: 2}
        ],
        rows: [],
        footColumns: {},
        exportHistiryModal: false,
        exportHeadColumns: [
          {label: this.$root.$t('statistic.user'), field: 'user'},
          {label: this.$root.$t('statistic.offer'), field: 'offer'},
          {label: this.$root.$t('statistic.webmaster'), field: 'externalWebmaster'},
          {label: this.$root.$t('statistic.date'), field: 'datetime'},
          {label: this.$root.$t('statistic.fix_from'), field: 'fix_from'},
          {label: this.$root.$t('statistic.fix_to'), field: 'fix_to'}
        ],
        exportRows: [],
        exportFootColumns: {}
      }
    },
    mounted () {
      this.calculateRows()
      this.$root.$on('filters_load_new_data', () => {
        this.calculateRows()
      })
    },
    methods: {
      calculateRows () {
        this.$root.$emit('data_loading')
        this.rows = []
        this.footColumns = {}
        API.getWebmasterPayments().then(response => {
          let statistic = {}
          let max = {
            average_payment: 0,
            last_payment: 0
          }
          let sumAveragePayment = 0
          let countAveragePayment = 0
          let sumBuyout = 0
          let countBuyout = 0
          let sumLastPayment = 0
          let countLastPayment = 0
          let sumPayment = 0
          let countPayment = 0
          let sumApproved = 0
          let sumReturn = 0
          let countReturn = 0
          let sumTotal = 0
          let countTotal = 0
          map(response.body, (webmasterData, id) => {
            if (parseInt(max.average_payment) < parseInt(webmasterData.average_payment)) {
              max.average_payment = webmasterData.average_payment
            }
            if (parseInt(max.last_payment) < parseInt(webmasterData.last_payment)) {
              max.last_payment = webmasterData.last_payment
            }
            statistic[id] = webmasterData
            statistic[id].webmaster_id = webmasterData.externalWebmaster
            statistic[id].average_payment = webmasterData.average_payment
            statistic[id].buyout = webmasterData.buyout
            statistic[id].last_payment = webmasterData.last_payment
            statistic[id].payment = webmasterData.payment_fix
            statistic[id].return = webmasterData.refunded
            statistic[id].approved = webmasterData.approved
            statistic[id].total = webmasterData.total
          })
          let offersList = Helper.getOffersList()
          let disable = ''
          if (offersList === '') {
            disable = 'disabled'
          }
          map(statistic, (d) => {
            sumTotal += parseInt(d.total)
            countTotal++
            if (d.average_payment > 0) {
              sumAveragePayment += parseInt(d.average_payment)
              countAveragePayment++
            }
            if (d.approved > 0) {
              sumApproved += parseInt(d.approved)
            }
            if (d.buyout > 0) {
              sumBuyout += parseInt(d.buyout)
              countBuyout++
            }
            if (d.last_payment > 0) {
              sumLastPayment += parseInt(d.last_payment)
              countLastPayment++
            }
            if (d.payment > 0) {
              sumPayment += parseInt(d.payment)
              countPayment++
            }
            if (d.return > 0) {
              sumReturn += parseInt(d.return)
              countReturn++
            }
            this.rows.push({
              webmaster: {
                value: d.webmaster_id
              },
              total: {
                value: d.total,
                bg: true
              },
              payment: {
                htmlValue: '<input class="cellInput" type="text" onchange="" ' + disable + ' value="' + d.payment + '" >',
                id: d.webmaster_id,
                oldvalue: d.payment
              },
              last_payment: {
                value: parseInt(d.last_payment),
                bgg: Helper.renderSingleGist(max.last_payment, d.last_payment)
              },
              average_payment: {
                value: parseInt(d.average_payment),
                bgg: Helper.renderSingleGist(max.average_payment, d.average_payment)
              },
              buyout: {
                value: parseInt(d.buyout),
                bgg: Helper.renderGistPart(d.approved, d.buyout),
                isCollspaned: true
              },
              buyoutPercents: {
                value: Helper.percents(d.approved, d.buyout),
                bgg: Helper.renderGistPart(d.approved, d.buyout, true)
              },
              return: {
                value: parseInt(d.return),
                bgg: Helper.renderGistPart(d.approved, d.return),
                isCollspaned: true
              },
              returnPercents: {
                value: Helper.percents(d.approved, d.return),
                bgg: Helper.renderGistPart(d.approved, d.return, true)
              }
              /* SpamAccept: {
                value: parseInt(d.SpamAccept),
                bg: true,
                bgg: Helper.renderGistPart(d.total, d.SpamAccept)
              } */
            })
          })
          this.footColumns = {
            label: {
              value: this.$root.$t('statistic.in_total')
            },
            total: {
              value: `${sumTotal} (${Helper.average(sumTotal, countTotal)})`
            },
            payment: {
              // value: `${sumPayment} (${Helper.average(sumPayment, countPayment)})`
              value: `${Helper.average(sumPayment, countPayment)}`
            },
            last_payment: {
              value: `${Helper.average(sumLastPayment, countLastPayment)}`
            },
            average_payment: {
              value: `${Helper.average(sumAveragePayment, countAveragePayment)}`
            },
            buyout: {
              value: `${sumBuyout} (${Helper.average(sumBuyout, countBuyout)})`
            },
            buyoutPercents: {
              value: Helper.percents(sumApproved, sumBuyout)
            },
            return: {
              value: `${sumReturn} (${Helper.average(sumReturn, countReturn)})`
            },
            returnPercents: {
              value: Helper.percents(sumApproved, sumReturn)
            }
          }
          this.$root.$emit('data_loaded')
        })
      },
      changeElem (cell, value) {
        this.confirmModal = true
        this.oldValue = cell
        this.ChangeValue = value
      },
      confirmValue (valueBool) {
        if (valueBool) {
          API.getWebmasterPaymentChange(this.oldValue.id, this.ChangeValue, this.oldValue.oldvalue).then(response => {
            this.calculateRows()
          })
        } else {
          this.calculateRows()
        }
        this.confirmModal = false
      },
      toggleExportHistoryModal () {
        if (!this.exportHistiryModal) {
          this.exportRows = []
          API.getWebmasterPaymentHistory().then((response) => {
            const orderedResponse = orderBy(response.body, ['date'], ['ASC'])
            orderedResponse.map((d) => {
              this.exportRows.push({
                user: {value: d.user, bg: true},
                offer: {value: Helper.getOfferTitle(Storage.offers, d.offer_id), bg: true},
                webmaster: {value: d.externalWebmaster, bg: true},
                date: {value: d.datetime, bg: true},
                fix_from: {value: d.fix_from, bg: true},
                fix_to: {value: d.fix_to, bg: true}
              })
            })
            this.exportHistiryModal = true
          }).catch((response) => {
            this.$notify({
              type: 'danger',
              title: this.$root.$t('verbs.error'),
              text: response.body.message ? response.body.message : response.body,
              animationType: 'velocity'
            })
          })
        } else {
          this.exportHistiryModal = false
        }
        return false
      },
      toggleBonusModal () {
        this.bonusModal = !this.bonusModal
      }
    }
  }
</script>

<style>
.cellInput{
  border:none;
  background: transparent;
  text-align: center
}
.cellInput:focus{
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// Payments.vue?6721b8bd